import React, { useRef,useEffect } from 'react'
import {change} from 'redux-form'
import Tooltip from '../../tooltip'

import PropTypes from 'prop-types'
function Toggle (props) {
  const { label, className, initialValue,meta,input,tooltip} = props
  const {dispatch,form} = meta
  const {name,value} = input
  const initFlag = useRef(false)
  const toggleCallback = () =>{
    dispatch(change(form,name,!value))
  }
  const renderTooltip = () =>{
    if(tooltip){
      const {button,description} = tooltip
      return (
        <Tooltip button={button} description={description} className={'of-toggle__tooltip'}/>
      )
    }
    return (<></>)
  }
  const renderLabel = () => {
    if(label){
      return (<div className={'of-toggle__label text-font-1-100'}>
        {label} is <span className={`value ${!value? 'text-font-3-100':''}`}>{value?' enabled':' disabled'}</span>
        {renderTooltip()}
      </div>)
    }
    return (<></>)
  }
  useEffect(()=>{
    if(!initFlag.current){
      if(initialValue!== undefined ){
        dispatch(change(form,name,initialValue))
      }
      initFlag.current = true
    }
  },[initFlag,dispatch,form,name,initialValue])
  return (
    <div className={`of-toggle${className ? ' ' + className : ''}${value?' of-toggle--on':''}`}>
      {renderLabel()}
      <div className={`of-toggle__wrapper${value?' primary-background-1-15':''}`} onClick={toggleCallback}>
        <div className={`of-toggle__circle ${value?' primary-background-1-100':''}`} />
        <input type={'hidden'} name={name} />
      </div>
    </div>
  )
}

Toggle.propTypes = {
  label: PropTypes.string,
  initialValue: PropTypes.bool,
  className: PropTypes.string,
  meta: PropTypes.any,
  input: PropTypes.any,
  tooltip: PropTypes.object
}

export default Toggle
